import { render, staticRenderFns } from "./AddMeasurement.vue?vue&type=template&id=85d766e2&"
import script from "./AddMeasurement.vue?vue&type=script&lang=js&"
export * from "./AddMeasurement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports